"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AprFormula = void 0;
exports.getApr = getApr;
/*
 * Enumeration of APR formala implementation names
 */
var AprFormula;
(function (AprFormula) {
    AprFormula[AprFormula["DEFAULT"] = 0] = "DEFAULT";
})(AprFormula || (exports.AprFormula = AprFormula = {}));
/**
 * Returns the specified draw fee formula implementation
 */
function getApr(formula) {
    switch (formula) {
        default:
            return default_apr;
    }
}
///////////////////////////
// Function Implementations
///////////////////////////
const default_apr = (drawAmount, drawFeeAmount, paymentAmount, periods, periodsPerYear, finalPaymentAmount) => {
    // ensure valid argument types
    if (typeof drawAmount === 'number' && typeof drawFeeAmount === 'number' && typeof paymentAmount === 'number' && typeof periods === 'number' && typeof periodsPerYear === 'number') {
        if (typeof finalPaymentAmount == "undefined")
            finalPaymentAmount = paymentAmount;
        return Math.round(rate(-(drawAmount - drawFeeAmount), periods, paymentAmount, finalPaymentAmount) * periodsPerYear * 10000) / 100;
    }
    return NaN;
};
/**
 * Calculates rate for APR
 */
function rate(presentValue, periods, paymentAmount, finalPaymentAmount) {
    if (typeof finalPaymentAmount == 'undefined')
        finalPaymentAmount = paymentAmount;
    const maxIterations = 200;
    const i0 = 0.1;
    const iMin = -1;
    const iMax = 5;
    let iterations = 0;
    let i = i0;
    let y;
    let left = iMin;
    let right = iMax;
    while (true) {
        if (iterations >= maxIterations) {
            // Reached max iterations
            break;
        }
        if (right - left < 0.0000001) {
            // Reached min precision
            break;
        }
        iterations++;
        let normalPaymentFactor = (Math.pow(1 + i, periods - 1) - 1) / (i * Math.pow(1 + i, periods - 1));
        let finalPaymentFactor = (Math.pow(1 + i, periods) - 1) / (i * Math.pow(1 + i, periods)) - normalPaymentFactor;
        y = paymentAmount * normalPaymentFactor + finalPaymentAmount * finalPaymentFactor + presentValue;
        if (y == 0) {
            // Reached exact zero (not likely to happen)
            return i;
        }
        if (y < 0) {
            right = i;
        }
        else {
            left = i;
        }
        i = (left + right) / 2;
    }
    return (left + right) / 2;
}
